import AreaChartGraph from './AreaChartGraph';

export default AreaChartGraph;
